import Vue from 'vue'
import Router from 'vue-router'
import grantActRouter  from './grantRouter'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   meta:{
    //     title:"报名专区"
    //   },
    //   component: (resolve) => {
    //     require(['@/components/index'], resolve)
    //   }
    // },
    // {
    {
        path: '/',
        name: 'index',
        meta:{
          title:"首页"
        },
        component: (resolve) => {
          require(['@/components/order-list'], resolve)
        }
    },
    {
        path: '/login',
        name: 'login',
        meta:{
          title:"登录"
        },
        component: (resolve) => {
          require(['@/components/login'], resolve)
        }
    },
    {
      path: '/order/list',
      name: 'orderList',
      meta:{
        title:"订单列表",
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/components/order-list'], resolve)
      }
    },
    {
      path: '/order/content/:id',
      name: 'orderContent',
      meta:{
        title:"订单详情"
      },
      component: (resolve) => {
        require(['@/components/order-content'], resolve)
      }
    },
    {
      path: '/takePhoto',
      name: 'takePhoto',
      meta:{
        title:"报名专区"
      },
      component: (resolve) => {
        require(['@/components/takePhoto'], resolve)
      }
    },
    {
      path: '/checkStatus',
      name: 'checkStatus',
      meta:{
        title:"报名结果"
      },
      component: (resolve) => {
        require(['@/components/checkStatus.vue'], resolve)
      }
    },
    {
      path: '/checkSuccess',
      name: 'checkSuccess',
      meta:{
        title:"报名成功"
      },
      component: (resolve) => {
        require(['@/components/checkSuccess.vue'], resolve)
      }
    },
    {
      path: '/checkFail',
      name: 'checkFail',
      meta:{
        title:"报名失败"
      },
      component: (resolve) => {
        require(['@/components/checkFail.vue'], resolve)
      }
    },
    {
      path: '/signIn',
      name: 'signIn',
      meta:{
        title:'签到'
      },
      component: (resolve) => {
        require(['@/components/signIn.vue'], resolve)
      },
    },
    {
      path: '/customerChat',
      name: 'customerChat',
      meta:{
        title:"联系客服"
      },
      component: (resolve) => {
        require(['@/components/customerChat.vue'], resolve)
      }
    },
    {
      path: '/containerBookingOrder',
      name: 'containerBookingOrder',
      meta:{
        title:"预定预提-订单"
      },
      component: (resolve) => {
        require(['@/components/containerBookingOrder.vue'], resolve)
      }
    },
    {
      path: '/containerBookingDetail',
      name: 'containerBookingDetail',
      meta:{
        title:"预定预提-订单详情"
      },
      component: (resolve) => {
        require(['@/components/containerBookingDetail.vue'], resolve)
      }
    },{
      path: '/containerBookingOrderChooseMail',
      name: 'containerBookingOrderChooseMail',
      meta:{
        title:"预定预提-选择寄单点"
      },
      component: (resolve) => {
        require(['@/components/containerBookingOrderChooseMail.vue'], resolve)
      }
    },{
      path: '/personalCenterNoAccess',
      name: 'personalCenterNoAccess',
      meta:{
        title:"个人中心"
      },
      component: (resolve) => {
        require(['@/components/personalCenterNoAccess.vue'], resolve)
      }
    },{
      path: '/personalCenterIntergral',
      name: 'personalCenterIntergral',
      meta:{
        title:"个人中心"
      },
      component: (resolve) => {
        require(['@/components/personalCenterIntergral.vue'], resolve)
      }
    },{
      path: '/',
      name: 'springFestival',
      meta:{
        title:"春节活动"
      },
      component: (resolve) => {
        require(['@/components/springFestival.vue'], resolve)
      }
    },{
      path: '/springFestivalActive',
      name: 'springFestivalActive',
      meta:{
        title:"春节活动"
      },
      component: (resolve) => {
        require(['@/components/springFestivalActive.vue'], resolve)
      }
    },
    {
      path: '/checkUser',
      name: 'checkUser',
      meta:{
        title:"认证"
      },
      component: (resolve) => {
        require(['@/components/checkUser.vue'], resolve)
      }
    },
    {
      path: '/copyMsg',
      name: 'copyMsg',
      meta: {
        title: '信息'
      },
      component: (resolve) => {
        require(['@/components/copyMsg/index.vue'], resolve)
      }
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: {
        title: '关于我们'
      },
      component: (resolve) => {
        require(['@/components/aboutUs/index.vue'], resolve)
      }
    },
    {
      path: '/serverProduct',
      name: 'serverProduct',
      meta: {
        title: '服务产品'
      },
      component: (resolve) => {
        require(['@/components/serverProduct/index.vue'], resolve)
      }
    },
    ...grantActRouter //奖学金助学活动路由

  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js